// Helpers de auth compartilhados pelos hooks de socket (chat + chat interno).

// Decodifica o exp do JWT localmente pra decidir se vale tentar refresh em
// connect_error/auth_required. Estrategia conservadora: refresh so se o token
// atual realmente parece expirado (decodificado < now).
export function isTokenExpired(token: string | null): boolean {
  if (!token) return true;
  try {
    const [, payloadB64] = token.split(".");
    if (!payloadB64) return false;
    // base64url -> base64
    const b64 = payloadB64.replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(b64);
    const payload = JSON.parse(json) as { exp?: number };
    if (!payload.exp) return false;
    // exp em segundos; consideramos expirado com 5s de buffer
    return payload.exp * 1000 <= Date.now() + 5_000;
  } catch {
    return false;
  }
}
